import { trackEvent } from "@/lib/analytics";

// Post-QR outcome events: once a QRIS code is on screen, these decompose the
// leak into webhook-reported failures, genuine expiries, retries, and guest
// dialog abandonment. They complement the cv_review_paid_upgrade funnel (which
// ends at checkout_created) and the server-side payment_success conversion.
export type PaymentOutcomeEvent =
  | "payment_failed"
  | "payment_expired"
  | "retry_clicked"
  | "checkout_abandoned";

/** Carried on `payment_expired` as `reason`; see usePaymentOutcomeTracking. */
export type PaymentExpiryReason = "countdown" | "qr_failed";

export interface PaymentOutcomeContext {
  paymentId: string;
  tier?: string | null;
  amount?: number | null;
  guest: boolean;
}

export function getPaymentOutcomePayload(
  context: PaymentOutcomeContext,
  properties?: UmamiEventData,
): UmamiEventData {
  return {
    ...(properties ?? {}),
    paymentId: context.paymentId,
    tier: context.tier ?? "unknown",
    amount: context.amount ?? 0,
    guest: context.guest,
  };
}

export function trackPaymentOutcomeEvent(
  eventName: PaymentOutcomeEvent,
  context: PaymentOutcomeContext,
  properties?: UmamiEventData,
) {
  trackEvent(eventName, getPaymentOutcomePayload(context, properties));
}
